const IconForgot = () => (
  <svg fill="none" height="12" viewBox="0 0 13 12" width="13">
    <mask id="a" fill="#fff">
      <path
        clipRule="evenodd"
        d="m3 1.5h9v7h-9zm-1-1h1 9 1v1 7 1h-1-.5v1.5.5h-.5-10.5-.5v-.5-8-.5h.5 1.5v-1zm0 3h-1v7h9.5v-1h-7.5-1v-1z"
        fill="#fff"
        fillRule="evenodd"
      />
    </mask>
    <path
      clipRule="evenodd"
      d="m3 1.5h9v7h-9zm-1-1h1 9 1v1 7 1h-1-.5v1.5.5h-.5-10.5-.5v-.5-8-.5h.5 1.5v-1zm0 3h-1v7h9.5v-1h-7.5-1v-1z"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      d="m12 1.5h1v-1h-1zm-9 0v-1h-1v1zm9 7v1h1v-1zm-9 0h-1v1h1zm-1-8v-1h-1v1zm11 0h1v-1h-1zm0 9v1h1v-1zm-1.5 0v-1h-1v1zm0 2v1h1v-1zm-11.5 0h-1v1h1zm0-9v-1h-1v1zm2 0v1h1v-1zm0 1h1v-1h-1zm-1 0v-1h-1v1zm0 7h-1v1h1zm9.5 0v1h1v-1zm0-1h1v-1h-1zm-8.5 0h-1v1h1zm10-9h-9v2h9zm1 8v-7h-2v7zm-10 1h9v-2h-9zm-1-8v7h2v-7zm1-2h-1v2h1zm9 0h-9v2h9zm1 0h-1v2h1zm1 2v-1h-2v1zm0 7v-7h-2v7zm0 1v-1h-2v1zm-2 1h1v-2h-1zm-.5 0h.5v-2h-.5zm-1-1v1.5h2v-1.5zm0 1.5v.5h2v-.5zm1-.5h-.5v2h.5zm-.5 0h-10.5v2h10.5zm-10.5 0h-.5v2h.5zm.5 1v-.5h-2v.5zm0-.5v-8h-2v8zm0-8v-.5h-2v.5zm-1 .5h.5v-2h-.5zm.5 0h1.5v-2h-1.5zm.5-2v1h2v-1zm0-1v1h2v-1zm1 2h-1v2h1zm-2 1v7h2v-7zm1 8h9.5v-2h-9.5zm10.5-1v-1h-2v1zm-8.5 0h7.5v-2h-7.5zm-1 0h1v-2h-1zm-1-2v1h2v-1zm0-5v5h2v-5z"
      fill="#46a7ed"
      mask="url(#a)"
    />
  </svg>
);

export default IconForgot;
